import axios from "axios";

const getEnhancedProductData = (seriesId, skuId) => {
  const seriesIdParam = seriesId ? `seriesid=${seriesId}` : "";
  const skuIdParam = skuId ? `skuid=${skuId}` : "";
  const joinSeriesAndSku = seriesIdParam && skuIdParam ? "&" : "";

  const url = `/ignitionapi/ProductService/Product?${seriesIdParam}${joinSeriesAndSku}${skuIdParam}`;
  const config = {
    headers: { Pragma: "no-cache" }
  };
  return axios.get(url, config);
};

const fetchSectionEnhancedProductOptionValues = (
  seriesId,
  Configurationid,
  SectionId,
  VariantCode,
  selectedOptions,
  requestPricing
) => {
  const url = `/ignitionapi/ProductService/GetSectionEnhancedProductOptionValues`;
  const config = getEnhancedPdpInputParam(
    seriesId,
    Configurationid,
    SectionId,
    VariantCode,
    selectedOptions,
    requestPricing
  );
  return axios.post(url, config);
};

const fetchBillOFMaterial = (
  seriesId,
  Configurationid,
  SectionId,
  VariantCode,
  selectedOptions,
  bomParts
) => {
  const url = `/ignitionapi/ProductService/GetBillOFMaterial`;
  let _selectedOptions = filterPartsFromSelectedOptions(
    selectedOptions,
    bomParts
  );
  const config = getEnhancedPdpInputParam(
    seriesId,
    Configurationid,
    SectionId,
    VariantCode,
    _selectedOptions
  );
  return axios.post(url, config);
};

const fetchPricingForBillOFMaterial = (
  productIds,
  customerNumber,
  salesOrg,
  useWeco
) => {
  const Ids = productIds.join(",");
  const url = `/ignitionapi/ProductService/ProductPrice?productIds=${Ids}&customerNumber=${customerNumber}&salesorg=${salesOrg}&useWeco=${useWeco}`;
  const config = {
    headers: { Pragma: "no-cache" }
  };
  return axios.get(url, config);
};

// NOTE: once this is no longer needed it can be removed
const addMAPOrderQuoteDetails = arrayEnhancedMapQuoterOrder => {
  const url = `/ignitionapi/ProductService/AddMAPOrderQuoteDetails`;
  return axios.post(url, arrayEnhancedMapQuoterOrder);
};

const fetchResources = (seriesId, skuId) => {
  const seriesIdParam = seriesId ? `seriesid=${seriesId}` : "";
  const skuIdParam = skuId ? `skuid=${skuId}` : "";
  const joinSeriesAndSku = seriesIdParam && skuIdParam ? "&" : "";

  const url = `/ignitionapi/ProductService/GetResources?${seriesIdParam}${joinSeriesAndSku}${skuIdParam}`;
  const config = {
    headers: { Pragma: "no-cache" }
  };

  return axios.get(url, config);
}

const fetchTools = (seriesId, skuId) => {
  const seriesIdParam = seriesId ? `seriesid=${seriesId}` : "";
  const skuIdParam = skuId ? `skuid=${skuId}` : "";
  const joinSeriesAndSku = seriesIdParam && skuIdParam ? "&" : "";

  const url = `/ignitionapi/ProductService/GetTools?${seriesIdParam}${joinSeriesAndSku}${skuIdParam}`;
  const config = {
    headers: { Pragma: "no-cache" }
  };

  return axios.get(url, config);
}

export default {
  getEnhancedProductData,
  fetchSectionEnhancedProductOptionValues,
  fetchBillOFMaterial,
  addMAPOrderQuoteDetails,
  fetchPricingForBillOFMaterial,
  fetchResources,
  fetchTools
};

// helper function
function getEnhancedPdpInputParam(
  seriesId,
  Configurationid,
  SectionId,
  VariantCode,
  selectedOptions,
  requestPricing
) {
  const selectedDropDownValues = selectedOptions
    ? getSelectedDropDownValues(selectedOptions)
    : [];

  return {
    EnhancedProductSeriesId: seriesId,
    Configurationid: Configurationid,
    SectionId: SectionId,
    VariantCode: VariantCode,
    SelectedDropDownValues: selectedDropDownValues,
    RequestPricing: requestPricing
  };
}

function getSelectedDropDownValues(selectedOptions) {
  let dropdownValues = [];
  for (var key of Object.keys(selectedOptions)) {
    for (var k of Object.keys(selectedOptions[key])) {
      dropdownValues.push({
        SelectedOptionName: selectedOptions[key][k].RulesKey,
        SelectedOptionValue: selectedOptions[key][k].Value,
        TranslationCode: selectedOptions[key][k].TranslationCode
      });
    }
  }

  return dropdownValues;
}

function filterPartsFromSelectedOptions(selectedOptions, bomParts) {
  let _tmpSelectedOptions = JSON.parse(JSON.stringify(selectedOptions));
  for (const [key, value] of Object.entries(bomParts)) {
    if (
      _tmpSelectedOptions[value.EnhancedSectionId] &&
      _tmpSelectedOptions[value.EnhancedSectionId][key]
    ) {
      delete _tmpSelectedOptions[value.EnhancedSectionId][key];
    }
  }
  return _tmpSelectedOptions;
}
